// extracted by mini-css-extract-plugin
module.exports = {"container":"TempButton_container__DDYNr"};